import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useApiSearchAdminMembers} from "@/api/userAcademy";
import TableSearch from "@/components/table/tableSearch";
import toFaNumber from "@/lib/utils/number";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import GenderComponent from "@/components/gender/GenderComponent";
import {Button} from "antd";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

function AdminMemberListPage(props) {
    const columns = [
        {
            title: 'شماره پرونده',
            dataIndex: 'code',
            key: 'code',
            responsive: ['md'],
            render: (text) => toFaNumber(text)
        },
        {
            title: 'نام و نام خانوادگی',
            dataIndex: 'firstname',
            key: 'firstname',
            render: (text, record) => {
                return (<>
                    <GenderComponent selfMode={true} text={record?.gender}/> {record?.firstname}
                    {' '}
                    <b>{record.lastname}</b>
                </>)

            }
        },
        {
            title: 'موبایل',
            dataIndex: 'mobile',
            key: 'mobile',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },
        {
            title: 'تاریخ',
            dataIndex: 'datecreated',
            key: 'datecreated',
            responsive: ['md'],
            render: (text) => convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
        },


        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return <Can permission={PermList.MEMBER_VIEW}> <Link
                    to={sprintf(URLS.admin.members.edit, {id: record.id})}><Button size={'small'}
                                                                                   variant={'filled'}
                                                                                   color={'primary'}>نمایش</Button></Link></Can>
            }
        },
    ];
    return (
        <AdminLayout pageTitle={'لیست اعضا'} backTo={URLS.admin.dashboard}>

            <TableSearch
                searchInput={true}
                apiFn={useApiSearchAdminMembers}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminMemberListPage;